"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_stringify_1 = require("dyna-stringify");
exports.consoleStringify = function () {
    var objs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objs[_i] = arguments[_i];
    }
    return '\n' + objs
        .map(function (obj) { return dyna_stringify_1.dynaStringify(obj, { spaces: 2 }); })
        .join('\n');
};
//# sourceMappingURL=consoleStringify.js.map